<template>
  <section class="table-sampler-result-chemical">
    <d-list-group flush class="custom-striped">
      <d-list-group-item
        class="d-flex px-3 py-4"
        v-for="(result, index) in model"
        v-bind:key="index"
      >
        <d-col class="col px-0">
          <d-form-row class="m-0 mb-1">
            <d-col cols="1">
              <label>Código</label>
              <input
                type="text"
                class="form-control"
                placeholder="Código"
                v-model="result.code"
                required
              />
            </d-col>
            <d-col cols="2">
              <label>Agente
                <template>
                  <i class="fas fa-info-circle p-0 fa-xs" :id="`tooltip-agent-${index}`"/>
                  <d-tooltip :target="`#tooltip-agent-${index}`" placement="top">
                    Este agente corresponde ao agente de posição {{ index + 1 }} na aba Memória de Campo.
                  </d-tooltip>
                </template>
                <small
                  class="link"
                  @click.prevent="openAgents(index)"
                  v-if="model[index]?.agent_id"
                >
                  Editar
                </small>
              </label>
              <autocomplete
                :ref="`autocomplete_agent_chemical_${index}`"
                placeholder="Agente quimico"
                :items="agents"
                item-show="name"
                :on-input="getListAgents"
                :on-select="(agent) => setAgentData(agent, index)"
                :on-show-text="showText"
                showIconClear
              />
            </d-col>
            <d-col cols="2">
              <label>Método</label>
              <input
                type="text"
                class="form-control"
                placeholder="Método"
                v-model="result.method"
                disabled
                required
              />
            </d-col>
            <d-col cols="1">
              <label>LQ</label>
              <select type="text" class="form-control" v-model="result.lq" @change="updateConclusion(index)" required>
                <option value="Abaixo">Abaixo</option>
                <option value="A cima">A cima</option>
              </select>
            </d-col>
            <d-col cols>
              <label>Resultado</label>
              <input
                type="text"
                class="form-control"
                placeholder="Resultado"
                v-model="result.result"
                @input="updateConclusion(index)"
                required
              />
            </d-col>
            <d-col cols="1">
              <label>Unidade</label>
              <select
                type="text"
                class="form-control"
                v-model="result.unity"
                required
              >
                <option value="ppm">ppm</option>
                <option value="mg/m³">mg/m³</option>
              </select>
            </d-col>
            <d-col cols>
              <label>TWA <small>(ACGIH)</small></label>
              <input
                type="text"
                class="form-control"
                placeholder="Twa"
                v-model="result.twa"
                @input="updateConclusion(index)"
                required
              />
            </d-col>
            <d-col cols>
              <label>NR-15</label>
              <input
                type="text"
                class="form-control"
                placeholder="NR-15"
                v-model="result.mp"
                @input="updateConclusion(index)"
                required
              />
            </d-col>
            <d-col cols>
              <label>Base cálculo</label>
              <select
                type="text"
                class="form-control"
                v-model="result.calculation_base"
                @change="updateConclusion(index)"
                required
              >
                <option value="TWA">TWA</option>
                <option value="NR-15">NR-15</option>
              </select>
            </d-col>
          </d-form-row>
          <d-form-row class="m-0 mb-1">
            <d-col cols="3">
              <label>Celling <small>(ACGIH)</small></label>
              <input
                type="text"
                class="form-control"
                placeholder="Celling"
                v-model="result.celling"
                required
              />
            </d-col>
            <d-col cols="3">
              <label>Teto <small>(NR 15)</small></label>
              <input
                type="text"
                class="form-control"
                placeholder="Teto"
                v-model="result.teto"
                required
              />
            </d-col>
            <d-col cols="3">
              <label>Tamanho aerodispersóides</label>
              <select
                type="text"
                class="form-control"
                v-model="result.size_aerodispersoides"
                required
              >
                <option value="Total">Total</option>
                <option value="Toraxico">Toraxico</option>
                <option value="Respirável">Respirável</option>
                <option value="Inalável">Inalável</option>
                <option value="n.a.">N.A.</option>
              </select>
            </d-col>
            <d-col cols>
              <label>STEL <small>(ACGIH)</small></label>
              <input
                type="text"
                class="form-control"
                placeholder="Stel"
                v-model="result.stel"
                required
              />
            </d-col>
          </d-form-row>
          <d-form-row class="m-0 mb-1">
            <d-col cols="6">
              <label>Ação no Organismo</label>
              <input
                type="text"
                class="form-control"
                placeholder="Ação no Organismo"
                v-model="result.action_in_body"
                disabled
                required
              />
            </d-col>
            <d-col cols="6">
              <label>Notações</label>
              <input
                type="text"
                class="form-control"
                placeholder="Notações"
                v-model="result.notion_skin"
                disabled
                required
              />
            </d-col>
          </d-form-row>
          <d-form-row class="m-0 mb-1">
            <d-col cols="2">
              <label>Fator desvio <small>(NR 15)</small></label>
              <input
                type="text"
                class="form-control"
                placeholder="Fator desvio"
                v-model="result.deviation_factor"
                required
              />
            </d-col>
            <d-col cols="4">
              <label>OSHA - IR</label>
              <input
                type="text"
                class="form-control"
                placeholder="OSHA - IR"
                v-model="result.osha"
                required
              />
            </d-col>
            <d-col cols="6">
              <label>Meio de dispersão</label>
              <autocomplete
                :ref="'autocomplete_dispersal_' + index"
                placeholder="Meio de dispersão"
                :items="getAutocompleteItems(index, 'dispersal')"
                item-show="name"
                :on-input="(name) => getList('dispersal', name, index)"
                :on-select="(item) => setData('dispersal', item, index)"
                :on-show-text="showText"
                :showMessageNotFound="false"
                showIconClear
              />
            </d-col>
          </d-form-row>
          <d-form-row class="m-0 mb-1">
            <d-col cols="2">
              <label>IPVS <small>(PPM)</small></label>
              <input
                type="text"
                class="form-control"
                placeholder="IPVS"
                v-model="result.ipvs"
                disabled
                required
              />
            </d-col>
            <d-col cols="2">
              <label>Limite de odor <small>(PPM)</small></label>
              <input
                type="text"
                class="form-control"
                placeholder="Limite de odor"
                v-model="result.odor_limit"
                disabled
                required
              />
            </d-col>
            <d-col cols="4">
              <label>Respirador recomendado</label>
              <input
                type="text"
                class="form-control"
                placeholder="Respirador recomendado"
                v-model="result.respirator"
                disabled
                required
              />
            </d-col>
            <d-col cols="4">
              <label>Conclusão</label>
              <input
                type="text"
                class="form-control"
                placeholder="Conclusão"
                v-model="result.conclusion"
                required
              />
            </d-col>
          </d-form-row>
        </d-col>
      </d-list-group-item>
    </d-list-group>
  </section>
</template>

<script>
import { mapActions } from 'vuex';

import Events from '_utils/events';
import { cloneDeep, filterNullNames } from '_utils';
import Autocomplete from '_shared/Autocomplete.vue';
import ProductService from '_services/rest/modules/product';
import { CHEMICAL } from '_modules/settings/components/SettingsModel';
import { AUTOCOMPLETE_TYPES, CHEMICAL_RESULT, MODAL_TYPE, _ADD_SAMPLE_AGENT_TAB_RESULT_, _ADD_SAMPLE_NEW_RESULT_TAB_RESULT_, _DELETE_SAMPLE_RESULT_TAB_RESULT_, _LOAD_MODEL_, _OPEN_MODAL_, _RELOAD_SAMPLE_AGENT_ } from '../../SampleModel';

export default {
  name: 'Sample-Result-Chemical',
  props: {
    result: {
      type: Array || Object,
      default: null,
    },
  },
  components: {
    Autocomplete,
  },
  data() {
    return {
      model: null,
      memory_field: null,
      defaultValueFields: ['dispersal'],
      optionsOriginal: {},
      options: {},
      agents: [],
    };
  },
  computed: {
    chemicalSettings() {
      const { chemical } = this.$store.state.settings.results;
      if (chemical) {
        return chemical;
      }
      return { ...CHEMICAL };
    },
    sample() {
      const { sample } = this.$store.state.sample;
      if (sample) {
        return sample;
      }
      return null;
    },
  },
  methods: {
    ...mapActions(['getSettings', 'setToggle', 'activeAlert']),
    getAutocompleteItems(index, type) {
      return this.options[index] && this.options[index][type]
        ? this.options[index][type]
        : [];
    },
    insertAutocompleteValues(results) {
      const keys = AUTOCOMPLETE_TYPES;

      results.forEach((row, rowIndex) => {
        keys.forEach(key => {
          const refName = `autocomplete_${key}_${rowIndex}`;
          const value = row[key];

          if (value) {
            this.setAutocompleteValue(refName, value);
          }
        });
      });
    },
    setModel() {
      if (this.result && Array.isArray(this.result) && this.result.length > 0) {
        this.model = cloneDeep(this.result);
        const filteredData = filterNullNames(this.chemicalSettings.options);

        this.model.forEach((_, index) => {
          this.updateConclusion(index);
          this.initializeAutocompleteOptions(index, filteredData);
        });

        this.$nextTick(() => {
          this.insertAutocompleteValues(this.model);
        });
      } else {
        const memoryField = this.sample.memory_field;
        this.model = [
          cloneDeep({
            ...CHEMICAL_RESULT,
            agent_chemical: memoryField?.agent || null,
            method: memoryField?.agent_method || null,
          }),
        ];
      }
    },
    addRow() {
      const newIndex = this.model.length;
      const newResult = cloneDeep(CHEMICAL_RESULT);
      this.model.push(newResult);

      const filteredData = filterNullNames(this.chemicalSettings.options);
      this.initializeAutocompleteOptions(newIndex, filteredData);

      this.updateConclusion(newIndex);
    },
    removeRow(index) {
      this.model.splice(index, 1);
      this.setModel();
      if (!this.model.length) this.addRow();
    },
    initializeAutocompleteOptions(index, filteredData = null) {
      const types = AUTOCOMPLETE_TYPES;

      const data =
        filteredData || filterNullNames(this.chemicalSettings.options);
      this.options[index] = {};
      this.optionsOriginal[index] = {};

      types.forEach(type => {
        const values = [...(data[type] || [])];
        this.options[index][type] = values;
        this.optionsOriginal[index][type] = values;

        if (this.shouldSetDefaultValue(type)) {
          this.setFirstAutocompleteValue(type, index);
        }
      });
    },
    shouldSetDefaultValue(type) {
      return this.defaultValueFields.includes(type);
    },
    setFirstAutocompleteValue(type, index) {
      const values = this.optionsOriginal?.[index]?.[type];
      if (!values || values.length === 0) return;

      const firstValue = values[0];
      if (this.model[index]) {
        this.model[index][type] = firstValue.name;
      }

      this.$nextTick(() => {
        const refName = `autocomplete_${type}_${index}`;
        this.setAutocompleteValue(refName, firstValue.name);
      });
    },
    updateConclusion(index) {
      const { conclusion, bgColor, riskLevel } = this.calculateConclusion(this.model[index]);
      Object.assign(this.model[index], { conclusion, bg_color: bgColor, risk_level: riskLevel });
    },
    calculateConclusion(item) {
      if (item.lq === 'Abaixo') return this.getLQConclusion();

      const result = this.toNumber(item.result);
      const reference = this.getReferenceValue(item);

      return result && reference ? this.getRiskConclusion(result / reference) : this.getDefaultConclusion();
    },
    getLQConclusion() {
      const { lq } = this.chemicalSettings;
      return {
        conclusion: lq?.conclusion || 'Abaixo do limite de quantificação',
        bgColor: lq?.color || '#E0E0E0',
        riskLevel: 'lq',
      };
    },
    setAutocompleteValue(refName, value) {
      const ref = this.$refs[refName];
      const component = Array.isArray(ref) ? ref[0] : ref;

      if (component) {
        component.$refs.input.value = value;
      }
    },
    setData(type, data, rowIndex) {
      if (!data && this.optionsOriginal[rowIndex]) {
        this.options[rowIndex][type] = [
          ...this.optionsOriginal[rowIndex][type],
        ];
      }

      if (this.model[rowIndex]) {
        this.model[rowIndex][type] = data?.name || null;
      }
    },
    getList(type, name, rowIndex) {
      const filterValue = name?.trim()?.toLowerCase() || '';

      if (this.model?.[rowIndex]) {
        this.model[rowIndex][type] = name;
      }

      const rowOptions = this.optionsOriginal?.[rowIndex]?.[type];

      if (!rowOptions) {
        this.options[rowIndex] = {
          ...(this.options[rowIndex] || {}),
          [type]: [],
        };
        return;
      }

      if (filterValue === '') {
        this.options[rowIndex][type] = [...rowOptions];
        return;
      }

      const filtered = rowOptions.filter(item =>
        item?.name?.toLowerCase().includes(filterValue));

      this.options = {
        ...this.options,
        [rowIndex]: {
          ...this.options[rowIndex],
          [type]: filtered,
        },
      };
    },
    showText(item) {
      return `${item.name}`;
    },
    getDefaultConclusion() {
      return { conclusion: '---', bgColor: '#cfcfc4', riskLevel: '---' };
    },
    getReferenceValue(item) {
      if (!item.calculation_base) return null;
      const field = item.calculation_base === 'TWA' ? 'twa' : 'mp';
      return this.toNumber(item[field]);
    },
    toNumber(value) {
      if (!value) return null;
      const num = parseFloat(String(value).replace(',', '.'));
      return !Number.isNaN(num) && num !== 0 ? num : null;
    },
    getRiskConclusion(ratio) {
      const { risks } = this.chemicalSettings;
      if (!risks) return this.getDefaultConclusion();

      const riskKeys = ['risk1', 'risk2', 'risk3', 'risk4'];

      const validRisk = riskKeys
        .map(key => ({ key, risk: risks[key] }))
        .find(({ risk }) => risk && this.isInRange(ratio, risk));

      if (validRisk) {
        const { key, risk } = validRisk;
        return {
          conclusion: risk.conclusion,
          bgColor: risk.color,
          riskLevel: key,
        };
      }

      return this.getDefaultConclusion();
    },
    isInRange(ratio, risk) {
      const min = this.toNumber(risk.min);
      const max = this.toNumber(risk.max);

      if (min && max) return ratio >= min && ratio < max;
      if (max) return ratio < max;
      if (min) return ratio >= min;
      return false;
    },
    toggleLoading() {
      this.loading = !this.loading;
      Events.$emit('loading', this.loading);
    },
    getListAgents(name = '') {
      this.toggleLoading();
      const params = {
        skip: 0,
        take: 10,
        search: name,
        slug: 'chemical',
      };
      return ProductService.getList(params)
        .then(response => {
          this.agents = response.list;
        })
        .finally(() => this.toggleLoading());
    },
    setAgentData(agent, index) {
      if (!this.model[index]) return;

      const updatedRow = {
        ...this.model[index],
        agent_id: agent?.id || null,
        agent_chemical: agent?.name || null,
        method: agent?.method || null,
        action_in_body: agent?.action_in_body || null,
        ipvs: agent?.ipvs || null,
        notion_skin: agent?.notion_skin || null,
        odor_limit: agent?.odor_limit || null,
        respirator: agent?.respirator || null,
      };

      this.$set(this.model, index, updatedRow);
      this.updateConclusion(index);
    },
    openAgents(index) {
      this.setToggle({ type: MODAL_TYPE, bool: true });
      Events.$emit(_OPEN_MODAL_, { agentId: this.result[index].agent_id, index, type: MODAL_TYPE });
    },
    handleLoadModel() {
      this.setModel();
    },
    processAgentUpdate(agent, isNewAddition = false) {
      const { resultIndex, name } = agent;
      this.setAgentData(agent, resultIndex);

      const displayValue = name || null;
      const refName = `autocomplete_agent_chemical_${resultIndex}`;

      this.setAutocompleteValue(refName, displayValue);

      if (isNewAddition) {
        this.activeAlert({
          message: 'Agente atualizado na aba Resultado.',
          theme: 'success',
        });
      }
    },
    handleReloadSampleAgent(agent) {
      this.processAgentUpdate(agent);
    },
    handleAddSampleAgent(agent) {
      this.processAgentUpdate(agent, true);
    },
    handleAddNewResult() {
      this.addRow();
    },
    handleDeleteResult(index) {
      this.removeRow(index);
    },
  },
  mounted() {
    this.getSettings().then(() => this.setModel());

    Events.$on(_LOAD_MODEL_, this.handleLoadModel);
    Events.$on(_RELOAD_SAMPLE_AGENT_, this.handleReloadSampleAgent);
    Events.$on(_ADD_SAMPLE_AGENT_TAB_RESULT_, this.handleAddSampleAgent);
    Events.$on(_ADD_SAMPLE_NEW_RESULT_TAB_RESULT_, this.handleAddNewResult);
    Events.$on(_DELETE_SAMPLE_RESULT_TAB_RESULT_, this.handleDeleteResult);
  },
  beforeDestroy() {
    Events.$off(_LOAD_MODEL_, this.handleLoadModel);
    Events.$off(_RELOAD_SAMPLE_AGENT_, this.handleReloadSampleAgent);
    Events.$off(_ADD_SAMPLE_AGENT_TAB_RESULT_, this.handleAddSampleAgent);
    Events.$off(_ADD_SAMPLE_NEW_RESULT_TAB_RESULT_, this.handleAddNewResult);
    Events.$off(_DELETE_SAMPLE_RESULT_TAB_RESULT_, this.handleDeleteResult);
  },
  watch: {
    model: {
      handler(value) {
        this.$emit('update:result', value);
      },
      deep: true,
    },
    chemicalSettings: {
      handler() {
        this.setModel();
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~_scss/overrides";

.table-sampler-result-chemical {
  margin-inline: -15px;
  .col-controls {
    max-width: 50px;
    .icon-controls {
      display: flex;
      gap: 10px;
      .fas {
        cursor: pointer;
      }
    }
  }
}
</style>
